import React, { useRef } from 'react';
import Container from '@mui/material/Container';
import { styled } from '@mui/material/styles';
import { useDispatch } from 'react-redux';

import { CaretIcon, Divider, Link, Typography } from '@tkww/the-bash-frontend';
import ProfileSummary from 'views/ProfileReviewsPage/ProfileSummary';
import ReviewsSection from 'views/ProfileReviewsPage/ReviewsSection';
import getProfileBreadCrumbs from 'helpers/profiles/getProfileBreadcrumbs';
import { profileReviewsPropTypes } from 'propTypes/profileReviews';
import BreadCrumbs from 'components/BreadCrumbs';
import { VendorStickyFooter } from 'components/Profile/VendorStickyFooter';
import { REQUEST_QUOTE_TEXT } from 'constants/Vendors';
import { gmConfig } from 'helpers/config';
import { profileReviewsRequestQuote } from 'state/modules/analytics/profile';

const StyledLink = styled(Link)({
  display: 'flex',
  alignItems: 'center',
});

const StandardReviewsPage = (props) => {
  const { profile, query: originalQuery } = props;
  const { profileUrl, profileName, id } = profile;
  const ctaRef = useRef(null);
  const dispatch = useDispatch();

  const profileBreadCrumbs = getProfileBreadCrumbs(profile, true);
  profileBreadCrumbs.push({
    label: 'Reviews',
  });

  const handleContactClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(profileReviewsRequestQuote('Profile Reviews Sticky CTA', REQUEST_QUOTE_TEXT, profile));
    window.location.assign(`https://${gmConfig.domains.www}/requestquote?memberId=${id}`);
  };

  return (
    <>
      <Container maxWidth="md">
        <BreadCrumbs items={profileBreadCrumbs} />
        <StyledLink
          data-testid="reviews-profile-link"
          path={profileUrl}
          nextPath="/[dir1]/[dir2]"
          type="standalone"
        >
          <CaretIcon direction="left" />
          Back to profile
        </StyledLink>
        <Typography
          variant="h1"
          sx={{
            marginTop: 1.5,
            marginBottom: '18px',
          }}
        >
          {profileName} Reviews
        </Typography>
        <ProfileSummary ref={ctaRef} profile={profile} />
        <Divider />
        <ReviewsSection profile={profile} originalQuery={originalQuery} />
      </Container>
      <VendorStickyFooter ctaRef={ctaRef} profile={profile} onClick={handleContactClick} />
    </>
  );
};

StandardReviewsPage.propTypes = profileReviewsPropTypes;

export default StandardReviewsPage;
